import { render, staticRenderFns } from "./swipertwo.vue?vue&type=template&id=5330ead8&scoped=true&"
import script from "./swipertwo.vue?vue&type=script&lang=js&"
export * from "./swipertwo.vue?vue&type=script&lang=js&"
import style0 from "./swipertwo.vue?vue&type=style&index=0&id=5330ead8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330ead8",
  null
  
)

export default component.exports